module.exports = __webpack_public_path__ + "static/media/pin.7f4752cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/detail-map/pin.svg
// module id = 445
// module chunks = 0